export default __webpack_public_path__ + "static/Fuel_Alex-Hansen-8d61fa057b92c0286e4cbdee1b53900b.jpeg";